// extracted by mini-css-extract-plugin
export default {"main":"ProvinciaSelector_main__Z7nDD"};